module.exports = __webpack_public_path__ + "img/menu-unfold.b9efb3fd.svg";